import { setDrawerOpen, setDrawerChildren } from '../../../store/drawerState.ts'
import { setDirectionsTo, setZoom } from '../../../store/mapState.ts'
import { MiniPetList } from '../../petDrawer/MiniPetList.tsx'
import { controlState } from '../../../store/controlState.ts'

// Track active polylines and markers so we can remove them on clear
let activePolylines: google.maps.Polyline[] = []
let activeMarkers: google.maps.marker.AdvancedMarkerElement[] = []

export const doRoute = async (
    map: any,
    travelMode: any,
    myPosition: google.maps.LatLng,
    directionsTo: google.maps.LatLng
) => {
    if (!map) return

    // Clear any existing route visuals first
    removeRouteVisuals()

    setDrawerChildren(null)

    // Keep zoom in sync after google changes it
    const listener = window.google.maps.event.addListener(map, 'idle', () => {
        const zoom = map?.getZoom()
        setZoom(zoom)
        window.google.maps.event.removeListener(listener)
    })

    try {
        const routesLib: any = await google.maps.importLibrary('routes')
        const Route = routesLib?.Route

        const request = {
            origin: myPosition,
            destination: directionsTo,
            travelMode: travelMode?.toUpperCase() || 'DRIVING',
            routeModifiers: {
                avoidTolls: true,
                avoidHighways: true,
            },
            fields: ['path', 'legs'],
        }

        const { routes } = await Route.computeRoutes(request)

        if (routes && routes.length > 0) {
            const route = routes[0]

            // Draw polylines on the map
            activePolylines = route?.createPolylines() || []
            activePolylines.forEach((polyline: google.maps.Polyline) => polyline.setMap(map))

            // Fit map to the route bounds
            const bounds = new google.maps.LatLngBounds()
            activePolylines.forEach((polyline: google.maps.Polyline) => {
                polyline.getPath().forEach((point: google.maps.LatLng) => bounds.extend(point))
            })
            map.fitBounds(bounds)

            controlState.directionsVisible = true
        } else {
            clearRoute()
        }
    } catch (e: any) {
        const m = e?.message?.split(':') || [e]
        window.alert(m[m.length - 1] || 'Route request failed')
        clearRoute()
    }
}

const removeRouteVisuals = () => {
    activePolylines.forEach((p: google.maps.Polyline) => p.setMap(null))
    activePolylines = []
    activeMarkers.forEach((m: google.maps.marker.AdvancedMarkerElement) => (m.map = null))
    activeMarkers = []
}

export const clearRoute = () => {
    setDirectionsTo(null)
    removeRouteVisuals()
    setDrawerOpen(false)
    setDrawerChildren(null)
    setTimeout(() => controlState.isOnMobileDevice ?
            setDrawerChildren(<MiniPetList/>)
            : setDrawerChildren(null)
        , 500)
}
